export class Usage {
    id:number;
    libelle: string;
    code: string;
    description: string;
    slug: string;
    actif: boolean;
}
